import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { Station } from 'src/app/interfaces/station.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-button-chat',
  templateUrl: './button-chat.component.html',
  styleUrls: ['./button-chat.component.scss']
})
export class ButtonChatComponent implements OnInit {

  @Output() chatClose = new EventEmitter<void>();
  @Input() station!: Station;

  stationName: string = environment.name;
  stationFrecuency!: string | null;
  phoneNumber: string = environment.contacto.telefono;
  sentMessage: string = environment.config.message;
  textMessage: string = environment.socialMedia.whatsApp;
  linkApi: string = `https://api.whatsapp.com/send?phone=${this.phoneNumber}&text=${this.textMessage}`;
  
  isChatOpen: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.setChatStatusBasedOnDevice();
  }

  ngOnChanges(changes: SimpleChange): void {
    if (changes['station'] && this.station) {
      this.stationFrecuency = this.station.frecuencia;
    }
  }

  goWhatsApp(){
    window.open(this.linkApi, '_blank');
  }
  
  openChat(){
    this.isChatOpen = !this.isChatOpen;
  }

  setChatStatusBasedOnDevice(): void {
    const isDesktop = window.innerWidth > 768;
    this.isChatOpen = isDesktop;
  }

}
